import { render, staticRenderFns } from "./DamEnsampleMobile.vue?vue&type=template&id=64797af2&scoped=true"
import script from "./DamEnsampleMobile.vue?vue&type=script&lang=ts"
export * from "./DamEnsampleMobile.vue?vue&type=script&lang=ts"
import style0 from "./DamEnsampleMobile.vue?vue&type=style&index=0&id=64797af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64797af2",
  null
  
)

export default component.exports